import { GET_RACE_SUCCESS } from './race';

export default (state = null, action) => {
    if (action.type === GET_RACE_SUCCESS) {
        const past = action.result['Past Training'];
        if (past) {
            return {
                longRun: past['Long Run'],
                runDays: past['Run Days'],
                experience: past['Running Experience'],
                volume: past['Volume Per Week'],
                raceExperience: past['Race Experience'],
            };
        }
    }
    return state;
};



/** WEBPACK FOOTER **
 ** ./src/redux/treningHistory.js
 **/